import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import TopBanner from './components/TopBanner';
import HotNews from './components/HotNews';
import VIPSection from './components/VIPSection';
import SpySection from './components/SpySection';
import AnalysisSection from './components/AnalysisSection';
import MatchTable from './components/MatchTable';
import SidebarBanners from './components/SidebarBanners';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="max-w-[1200px] mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-9">
            <TopBanner />
            <HotNews />
            <VIPSection />
            <SpySection />
            <AnalysisSection />
            <MatchTable />
          </div>
          
          <div className="lg:col-span-3">
            <SidebarBanners />
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
